import mitt from 'mitt'

const EventEmitter = mitt()

export { EventEmitter }

/**
There are already a couple of signals defined:

signalError({ error: error }) - central error handling
Used in:
- components/push_apis/S3PushOverview.js (emitted)
- components/Main.js (received)

signalProfileTabChanged({ activeIndex: activeIndex }) - sync Tabs in different cards
Used in:
- components/cards/ApiFeedUrlBrowser.js (emitted)
- components/cards/ApiJsonContentBrowser.js (received)

- components/cards/ApiJsonContentBrowser.js (emitted)
- components/cards/ApiFeedUrlBrowser.js (received)

*/



// WEBPACK FOOTER //
// ./src/components/error_handling/EventEmitter.js